import React, { useEffect, useMemo, useState } from 'react'
import { Button, Grid } from '@mui/material'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from 'date-fns/locale/es';
import { IDropdown } from 'shared/models'
import {  useSelector } from 'react-redux'
import { RootState } from 'shared/store/store'
import styles from './formFilter.module.scss'
import 'pages/read-documents/styles/_readDocumentsMUI.scss';
import { ComboBoxCustom } from 'shared/components/ComboBoxCustom';
import { IFieldForm } from 'pages/read-documents/model/IFieldForm';
import 'dayjs/locale/es'
import { Spinner } from 'shared/components';
import { DatePickerConfig } from '../../../pages/autorization-payments/types';
import { ModalStates } from 'pages';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';

registerLocale('es', es)

interface IFormFilter {
    dataFields:IFieldForm[],
    inputFieldState?: any,
    values: any,
    handleSubmit?: (e?: React.FormEvent<HTMLFormElement> | undefined) => void,
    handleChange: (e: React.ChangeEvent<any>)=> void,
    getValueDatePickerStart: (name: keyof DatePickerConfig) => Date | null,
    getValueDatePickerEnd: (name: keyof DatePickerConfig) => Date | null,
    maxDate: (name: keyof DatePickerConfig) => Date,
    onChangesDatePicker: (update: any, name: string) => void,
    handleUserAssignment: (value: any) => void,
    validateActivitiesSelected?: ()=> boolean,
    handleClear?: () => void
}

export const FormFilter = (props:IFormFilter) => {
    const {
        dataFields,
        inputFieldState,
        values,
        handleSubmit,
        handleChange,
        getValueDatePickerStart,
        getValueDatePickerEnd,
        maxDate,
        onChangesDatePicker,
        handleUserAssignment,
        validateActivitiesSelected,
        handleClear
    } = props;

    const { loading } = useSelector((rootState: RootState) => rootState.loading.models.electronicDocuments);
    const [openModalStates, setOpenModalStates] = useState(false);
    const onCloseModal = () => setOpenModalStates(false)
    
    const getValue = (name:string)=> {
        const valueField: any = Object.entries(values).find(([key, value])=> key === name);
        return valueField[1]
    } 
    
    return (
        <>
            <form className={`${styles.formReadDocuments} form-documents`} noValidate onSubmit={handleSubmit} data-testid='form-read-documents'>
                <Grid container direction={"row"} className={styles.containerReadDocuments}>
                {
                    dataFields.map((field,i)=> (
                        <Grid item xs={12} md={6} lg={3} className={ styles.containerGridItem } key={i}>
                            {
                                field.type === 'text' &&
                                    <>
                                        <label htmlFor={field.id}>
                                            {field.label}
                                        </label>
                                        <input 
                                            type='text'
                                            name={field.name}
                                            placeholder={field.placeholder}
                                            id={field.id}
                                            data-testid={field.testId}
                                            value={ getValue(field.name) }
                                            onChange={handleChange}
                                        />
                                    </>
                            }
                            {
                                field.type === 'number' &&
                                    <>
                                        <label htmlFor={field.id}>
                                            {field.label}
                                        </label>
                                        <input 
                                            type='number'
                                            name={field.name}
                                            placeholder={field.placeholder}
                                            id={field.id}
                                            data-testid={field.testId}
                                            value={ getValue(field.name) }
                                            onChange={handleChange}
                                        />
                                    </>
                            }
                            {
                                field.type === 'Select' &&
                                    <>
                                        <label htmlFor={field.id}>
                                            {field.label}
                                        </label>
                                        <select 
                                            name={field.name}
                                            id={field.id}
                                            data-testid={field.testId}
                                            value={getValue(field.name)}
                                            onChange={handleChange}
                                            disabled={!field.isEnable}
                                        >
                                            <option value="" disabled hidden> {field.placeholder}</option>
                                            {
                                                field?.options?.map((opcion: IDropdown) => (
                                                    <option key={opcion.id + i} value={opcion.id}>
                                                        {opcion.name}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </>
                            }
                            {
                                field.type === 'datePicker' &&
                                <>
                                    <label htmlFor={field.id} className='ellipsisCustom width-90Porcent'>
                                        {field.label}
                                    </label>
                                    <DatePicker
                                        id={field.id}
                                        selectsRange={true}
                                        startDate={getValueDatePickerStart(field.name)}
                                        endDate={getValueDatePickerEnd(field.name)}
                                        onChange={(update) => onChangesDatePicker(update, field.name)}
                                        isClearable={true}
                                        locale={'es'}
                                        dateFormat="dd/MM/yyyy" 
                                        showMonthDropdown
                                        showYearDropdown
                                        data-testid={field.testId}
                                        placeholderText='DD/MM/AAAA'
                                        maxDate={ maxDate(field.name) }
                                    />
                                </>
                            }
                            {
                                field.type === 'Autocomplete' &&
                                <>
                                    <span className={styles.spanForLabel}>
                                        {field.label}
                                    </span>
                                    <ComboBoxCustom handleChange={handleUserAssignment} data={field.options!} placeholder='Seleccione un usuario' focusSelected={true} inputFieldState={inputFieldState}/>
                                </>
                            }
                            {
                                field.type === 'modal' &&
                                <>
                                    <span className={styles.spanForLabel}>
                                        {field.label}
                                    </span>
                                    <input
                                        className={styles.selectStates}
                                        onClick={ ()=> setOpenModalStates(true) }
                                        value={validateActivitiesSelected && validateActivitiesSelected()  ? 'Actividades seleccionadas' : 'Seleccione Actividades' }
                                        readOnly={true}
                                        id='selectStates'
                                        data-testid='select_states'
                                    />
                                    {
                                        validateActivitiesSelected && validateActivitiesSelected() 
                                            ? <CheckIcon className={styles.checkIcon} data-testid="check_icon"/>
                                            : <KeyboardArrowDownIcon className={styles.iconArrow} onClick={()=>setOpenModalStates(true)} data-testid='keyboard_arrow_down_icon'/>
                                    }
                                </>
                            }
                        </Grid>
                        
                    ))
                }
                {
                    handleSubmit &&
                        <Grid container direction={"row"} justifyContent={'center'} spacing={2} className={styles.buttonContainer}>
                            <Grid item>
                                <Button type='submit' variant='contained' color='secondary' className={styles.buttonSubmit} data-testid="btn-submit">
                                    Consultar
                                </Button>
                            </Grid>
                            {
                                handleClear &&
                                    <Grid item>
                                        <Button type='button' variant='outlined' color='secondary' className={styles.buttonSubmit} onClick={handleClear} data-testid="btn-clear">
                                            Limpiar
                                        </Button>
                                    </Grid>
                            }
                        </Grid>
                }
                </Grid>

            </form>

            <ModalStates
                onCloseModal={onCloseModal}
                openModal={openModalStates}
                isSelectedFieldIsADifferentInvoice={false}
            />
            
            {(loading) && <Spinner/>}
        </>

    )
}